import React from 'react'
import { browserHistory } from 'react-router';

import NavLink from '../../Routes/NavLink'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { user } from '../../../core/controllers/user'
import { payables } from '../../../core/controllers/Payables'

export default class VendorBillList extends React.Component {
    constructor(props) {
        super(props);
        this.index = 0;
        this.lastFilter = props.filter;

        this.state = {
            vendorBillsData: null,
            user_info: {
                userType: null
            }
        }
    }

    componentDidMount() {
        var self = this;
        payables.getVendorBills(function(response) {
            user.getUserInfo(function(user) {
                self.setState({
                    user_info: user.data,
                    vendorBillsData: response.data
                })
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
        var self = this;
        if(this.lastFilter != nextProps.filter) {
            this.lastFilter = nextProps.filter;
            vendors.getVendorBills(this.lastFilter, function(response) {
                self.setState({
                    vendorBillsData: response.data
                });
            });
        }
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
     formatAmount(value) {
        // format money
        var money = parseFloat(value) / 100;
        money = new Intl.NumberFormat('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(money)
        return money;
    }

    formatMoney(cell, row) {
        return '$' + this.formatAmount(row.amount); //TODO: Change to correct variable
    }

    formatStatus(cell, row) {
        var status = '<span class="important-small-orange">NEW</span>';
        if (cell == 'NEW') {
            status = '<span class="important-small-blue">NEW</span>';
        } else if (cell == 'IN_REVIEW') {
            status = '<span class="important-small-orange">IN REVIEW</span>';
        } else if (cell == 'APPROVED') {
            status = '<span class="important-small-green">APPROVED</span>';
        } else if (cell == 'DECLINED') {
            status = '<span class="important-small-red">DECLINED</span>';
        } else if (cell == 'PAID') {
            status = '<span class="important-small-green">PAID</span>';
        } else if (cell == 'CANCELLED') {
            status = '<span class="important-small-gray">CANCELLED</span>';
        }
        return status;
    }

    didSelectRow(row) {
        browserHistory.push('/payables/bills/' + row.vendor_bill_id);
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    formatDate(cell, row) {
        if(cell) {
            return moment(cell).format('D MMM YYYY');
        } else {
            return 'Not Set';
        }
    }

    formatVendor(cell, row) {
        return (
            <span onClick={this}>
                <NavLink to={'/payables/vendors/' + row.vendor_id}>{row.name}</NavLink>
            </span>
        )
    }

    render(){
        const userType = this.state.user_info.user_type;
        var vendorBillsData = this.state.vendorBillsData;
        if (vendorBillsData != null) {
            vendorBillsData = this.state.vendorBillsData.map(function(bill) {
                const formatData = {
                    title: bill.bill.title,
                    description: bill.bill.description,
                    hours: bill.bill.hours,
                    amount: bill.bill.amount,
                    due_at: bill.bill.due_at,
                    status: bill.bill.status,
                    vendor_bill_id: bill.bill.vendor_bill_id,
                    name: bill.vendor.company_name,
                    vendor_id: bill.bill.created_by
                };
                return formatData;
            });
        }

        const options = {
            onRowClick: this.didSelectRow
        };

        return (
            <div class="row">
                <div class="col-md-12">
                    <div class="content">
                        {vendorBillsData != null && vendorBillsData.length > 0 ? (
                            window.innerWidth < 992 ? (
                            <BootstrapTable data={vendorBillsData} version='4' striped search pagination hover options={options}>
                                <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='title' dataSort={ true }>Title</TableHeaderColumn>
                                <TableHeaderColumn dataField='amount' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount</TableHeaderColumn>
                                <TableHeaderColumn dataField='due_at' dataFormat={this.formatDate.bind(this)} dataSort={ true }>Due Date</TableHeaderColumn>
                            </BootstrapTable>
                            ) : (
                                userType == 'vendor' ? (
                                    <BootstrapTable data={vendorBillsData} version='4' striped search pagination hover options={options}>
                                        <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                        <TableHeaderColumn dataField='title' dataSort={ true }>Title</TableHeaderColumn>
                                        <TableHeaderColumn dataField='description' dataSort={ true }>Description</TableHeaderColumn>
                                        <TableHeaderColumn dataField='hours' dataSort={ true }>Hours</TableHeaderColumn>
                                        <TableHeaderColumn dataField='amount' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount</TableHeaderColumn>
                                        <TableHeaderColumn dataField='due_at' dataFormat={this.formatDate.bind(this)}  dataSort={ true }>Due Date</TableHeaderColumn>
                                        <TableHeaderColumn dataField='status' width="120" dataFormat={this.formatStatus.bind(this)} dataSort={ true }>Status</TableHeaderColumn>
                                    </BootstrapTable>
                                ) : (
                                    <BootstrapTable data={vendorBillsData} version='4' striped search pagination hover options={options}>
                                        <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                        <TableHeaderColumn dataField='title' dataSort={ true }>Title</TableHeaderColumn>
                                        <TableHeaderColumn dataField='description' dataSort={ true }>Description</TableHeaderColumn>
                                        <TableHeaderColumn dataField='hours' dataSort={ true }>Hours</TableHeaderColumn>
                                        <TableHeaderColumn dataField='name' dataFormat={this.formatVendor.bind(this.stopSelectRow)} dataSort={ true }>Vendor</TableHeaderColumn>
                                        <TableHeaderColumn dataField='amount' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount</TableHeaderColumn>
                                        <TableHeaderColumn dataField='due_at' dataFormat={this.formatDate.bind(this)}  dataSort={ true }>Due Date</TableHeaderColumn>
                                        <TableHeaderColumn dataField='status' width="120" dataFormat={this.formatStatus.bind(this)} dataSort={ true }>Status</TableHeaderColumn>
                                    </BootstrapTable>
                                )
                            )
                        ) : (
                            <p class="col-md-12">No bills found.</p>
                        )}
                    </div>
                    <div class="content" style={{float:"right"}}>
                        <NavLink to={"/payables/bills/new"}>
                            <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off">
                                Create Bill
                            </button>
                            <div class="clearfix"></div>
                        </NavLink>
                    </div>
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Payables/Bills/VendorBillList.jsx